import React from "react";
import { connect } from "react-redux";
import { CorperateProductSetDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { AlertControl } from "components/Modals/Alert";
import { toast } from "react-toastify";
import moment from "moment";
import { ROUTE_PATH } from "utils/constants/routePath";
import {
  FETCH_BUSINESS_UNIT_OPTIONS,
  MAP_PRODUCT_SET_FORM_TO_FORMDATA,
  MAP_PRODUCT_SET_TO_FORM,
  RENDER_PRODUCT_SET_TIMELINE,
} from "utils/functions/corperate";
import { Displays, Forms } from "components";

// สถานะ Set → โหมดของฟอร์ม: 1 Draft, 3 Pending Approve, 2 Approved (ล็อค)
const MODE_BY_STATUS = { 1: "draft", 3: "pending", 2: "locked" };

// ใช้ทั้งหน้า Set ของ Corperate (/list/:id/set/:setId) และหน้า PendingApproved (/pending-approved/:setId)
class CorperateProductSetDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  // หน้า Set และหน้า PendingApproved ใช้ container เดียวกัน React จะใช้ instance เดิมเมื่อเปลี่ยน route
  // จึงต้องโหลดใหม่ทุกครั้งที่ path เปลี่ยน ไม่ใช่แค่ setId
  componentDidUpdate(prevProps) {
    if (
      prevProps.router.location.pathname !== this.props.router.location.pathname
    ) {
      this.setState({ isLoading: true });
      this.fetchData();
    }
  }

  fetchData = async () => {
    const { id, setId } = this.props.router.params;
    const isCreate = setId === "create";
    let [buOptions, res, resLog] = await Promise.all([
      FETCH_BUSINESS_UNIT_OPTIONS(portalService),
      isCreate ? null : portalService.GET_CORPERATE_PRODUCT_SET_DETAIL(setId),
      isCreate
        ? null
        : portalService.GET_CORPERATE_PRODUCT_SET_ACTION_LOG(setId),
    ]);
    if (isCreate) {
      this.setState({
        buOptions,
        mode: "create",
        initialValues: {
          organization_ref_id: id,
          set_date: moment().format("YYYYMMDD"),
          business_unit_ref_id: "ALL",
          product_warranty_list: [{ info: { name: "" } }],
        },
        timelineItems: [],
        itemErrors: {},
        canSendApprove: false,
        isLoading: false,
        isBgLoading: false,
      });
    } else if (res && res.status === 200) {
      const itemErrors = await this.fetchItemErrors(res.data);
      this.setState({
        itemErrors,
        buOptions,
        mode: MODE_BY_STATUS[res.data.status] || "locked",
        initialValues: MAP_PRODUCT_SET_TO_FORM(res.data),
        timelineItems:
          resLog && resLog.status === 200
            ? RENDER_PRODUCT_SET_TIMELINE(resLog.data)
            : [],
        // Draft ที่เคยบันทึกวิธีการรับประกันไว้แล้ว ส่งอนุมัติต่อได้เลย
        canSendApprove: !!res.data.warranty_method,
        isLoading: false,
        isBgLoading: false,
      });
    } else {
      toast.error("ไม่พบข้อมูล Product Set");
      this.setState({ isLoading: false, initialValues: null });
    }
  };

  // Set ที่ยังไม่อนุมัติ ตรวจว่า serial แต่ละตัวยังใช้ได้ไหม (เช่น หลัง Reject ถูก Set อื่นจองไป)
  fetchItemErrors = async (set) => {
    if (set.status === "2" || !(set.product_warranty_list || []).length) {
      return {};
    }
    const res = await portalService.POST_CORPERATE_PRODUCT_SET_CHECK_SERIAL({
      product_warranty_ids: set.product_warranty_list.map(
        (e) => e.product_warranty_id
      ),
      product_warranty_set_id: set._id,
    });
    return res && res.status === 200
      ? res.data.reduce((result, e) => {
          if (!e.is_valid) result[e.product_warranty_id] = e.reason;
          return result;
        }, {})
      : {};
  };

  handleClickBack = () => {
    this.props.router.navigate(-1);
  };

  // หลัง Approve/Reject กลับไปหน้ารายการที่มา (PendingApproved หรือ Set ขององค์กร)
  handleBackToList = () => {
    const { router } = this.props;
    const { initialValues } = this.state;
    router.navigate(
      router.location.pathname.includes("/pending-approved/")
        ? ROUTE_PATH.CORPERATE_PENDING_APPROVED
        : ROUTE_PATH.CORPERATE_DETAIL.replace(
            ":id",
            initialValues.organization_ref_id
          )
    );
  };

  handleResponse = (res, successMessage, onSuccess) => {
    if (res && res.status === 200) {
      toast.success(successMessage);
      this.setState({ itemErrors: {} });
      onSuccess();
    } else {
      const error = res?.data?.error;
      // serial ที่ใช้ไม่ได้ แสดงใต้ item แต่ละตัว
      this.setState({
        isBgLoading: false,
        ...(error?.items
          ? {
              itemErrors: error.items.reduce((result, e) => {
                result[e.product_warranty_id] = e.reason;
                return result;
              }, {}),
            }
          : {}),
      });
      toast.error(error?.message || "บันทึกไม่สำเร็จ");
    }
  };

  handleCreate = async (values) => {
    this.setState({ isBgLoading: true });
    const res = await portalService.POST_CORPERATE_PRODUCT_SET_DETAIL(
      MAP_PRODUCT_SET_FORM_TO_FORMDATA(values, { isCreate: true })
    );
    this.handleResponse(res, `สร้าง Set ${res?.data?.code || ""} สำเร็จ`, () =>
      // ไปหน้า Draft ของ Set ที่สร้าง เพื่อเลือกวิธีการรับประกันต่อ
      this.props.router.navigate(
        ROUTE_PATH.CORPERATE_SET_DETAIL.replace(
          ":id",
          values.organization_ref_id
        ).replace(":setId", res.data._id),
        { replace: true }
      )
    );
  };

  handleRequest = async (request, values, successMessage, onSuccess) => {
    const { setId } = this.props.router.params;
    this.setState({ isBgLoading: true });
    const res = await request(
      setId,
      values ? MAP_PRODUCT_SET_FORM_TO_FORMDATA(values) : undefined
    );
    this.handleResponse(res, successMessage, onSuccess || this.fetchData);
  };

  handleSubmit = (values, action) => {
    switch (action) {
      case "save_draft_next":
        this.handleCreate(values);
        break;
      case "save_draft":
        this.handleRequest(
          portalService.PUT_CORPERATE_PRODUCT_SET_SAVE_DRAFT,
          values,
          "บันทึก Draft สำเร็จ"
        );
        break;
      case "send_approve":
        AlertControl.show({
          title: "แจ้งเตือน",
          description:
            "คุณต้องการที่จะบันทึก และส่งข้อมูลเข้าสู่ระบบ เพื่อรอการยืนยันจากแอดมิน",
          btnLabel1: "ยกเลิก",
          btnLabel2: "ยืนยัน",
          onEvent2: () =>
            this.handleRequest(
              portalService.PUT_CORPERATE_PRODUCT_SET_SEND_APPROVE,
              values,
              "ส่งอนุมัติสำเร็จ"
            ),
        });
        break;
      case "approve":
        AlertControl.show({
          title: "แจ้งเตือน",
          description: "หาก Approve สินค้าทุกตัวจะเปลี่ยนเป็น “Under Warranty”",
          btnLabel1: "ยกเลิก",
          btnLabel2: "ยืนยัน",
          onEvent2: () =>
            this.handleRequest(
              portalService.PUT_CORPERATE_PRODUCT_SET_APPROVE,
              values,
              "Approve สำเร็จ",
              this.handleBackToList
            ),
        });
        break;
      case "reject":
        // Reject ไม่บันทึกค่าที่แก้ในหน้านี้ Set กลับเป็น Draft และปลดจอง serial ทั้งหมด
        AlertControl.show({
          title: "แจ้งเตือน",
          description:
            "ยืนยันการ Reject? Set จะกลับเป็น Draft และสินค้าทั้งหมดจะถูกปลดจอง ข้อมูลประกันของสินค้าจะไม่ถูกเปลี่ยนแปลง",
          btnLabel1: "ยกเลิก",
          btnLabel2: "ยืนยัน",
          onEvent2: () =>
            this.handleRequest(
              portalService.PUT_CORPERATE_PRODUCT_SET_REJECT,
              null,
              "Reject สำเร็จ",
              this.handleBackToList
            ),
        });
        break;
      default:
        break;
    }
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isLoading,
      isBgLoading,
      mode,
      initialValues,
      buOptions,
      timelineItems,
      itemErrors,
      canSendApprove,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "corperate");
    return (
      <CorperateProductSetDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          initialValues && (
            <>
              <div className="title">
                {mode === "create"
                  ? "Create Set"
                  : `${initialValues.organization_name || "Product Set"} / ${
                      initialValues.code
                    }`}
              </div>
              <Forms.CorperateProductSetForm
                mode={mode}
                setId={mode === "create" ? null : initialValues._id}
                initialValues={initialValues}
                buOptions={buOptions}
                permission={permission}
                canSendApprove={canSendApprove}
                timelineItems={timelineItems}
                itemErrors={itemErrors}
                onCancel={this.handleClickBack}
                onSubmit={this.handleSubmit}
              />
            </>
          )
        )}
      </CorperateProductSetDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CorperateProductSetDetailContainer));
